import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ClockIcon, ArrowRightIcon } from 'lucide-react';
import { Product } from '../../types';
import { ProductCard } from '../products/ProductCard';
interface DealsSectionProps {
  products: Product[];
}
export function DealsSection({
  products
}: DealsSectionProps) {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 59
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return {
          hours: 23,
          minutes: 59,
          seconds: 59
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <section className="py-12 bg-gradient-to-r from-red-600 to-orange-500" aria-labelledby="deals-heading" data-id="element-134">
      <div className="max-w-7xl mx-auto px-4" data-id="element-135">
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-8" data-id="element-136">
          <div className="text-white" data-id="element-137">
            <h2 id="deals-heading" className="text-2xl md:text-3xl font-bold mb-1" data-id="element-138">
              🔥 Deals of the Day
            </h2>
            <p className="text-white/80" data-id="element-139">
              Limited time offers - Don't miss out!
            </p>
          </div>

          <div className="flex items-center gap-4" data-id="element-140">
            <div className="flex items-center gap-2 text-white" data-id="element-141">
              <ClockIcon className="w-5 h-5" data-id="element-142" />
              <span className="font-medium" data-id="element-143">Ends in:</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-144">
              <div className="bg-white text-gray-900 px-3 py-2 rounded-lg text-center min-w-[60px]" data-id="element-145">
                <span className="text-xl font-bold" data-id="element-146">
                  {String(timeLeft.hours).padStart(2, '0')}
                </span>
                <p className="text-xs text-gray-500" data-id="element-147">Hours</p>
              </div>
              <span className="text-white text-xl font-bold" data-id="element-148">:</span>
              <div className="bg-white text-gray-900 px-3 py-2 rounded-lg text-center min-w-[60px]" data-id="element-149">
                <span className="text-xl font-bold" data-id="element-150">
                  {String(timeLeft.minutes).padStart(2, '0')}
                </span>
                <p className="text-xs text-gray-500" data-id="element-151">Mins</p>
              </div>
              <span className="text-white text-xl font-bold" data-id="element-152">:</span>
              <div className="bg-white text-gray-900 px-3 py-2 rounded-lg text-center min-w-[60px]" data-id="element-153">
                <span className="text-xl font-bold" data-id="element-154">
                  {String(timeLeft.seconds).padStart(2, '0')}
                </span>
                <p className="text-xs text-gray-500" data-id="element-155">Secs</p>
              </div>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6" data-id="element-156">
          {products.slice(0, 4).map(product => <ProductCard key={product.id} product={product} data-id="element-157" />)}
        </div>

        <div className="mt-8 text-center" data-id="element-158">
          <Link to="/products?deals=true" className="inline-flex items-center gap-2 bg-white text-gray-900 px-6 py-3 rounded-lg font-medium hover:bg-gray-100 transition-colors" data-id="element-159">
            View All Deals
            <ArrowRightIcon className="w-4 h-4" data-id="element-160" />
          </Link>
        </div>
      </div>
    </section>;
}